import { Button } from "@/components/ui/button";
import {
  Instagram,
  MessageCircle,
  Mail,
  MapPin,
} from "lucide-react";

const CONTACT_CHANNELS = [
  {
    icon: Instagram,
    label: "Instagram",
    value: "@thezumocompany",
    href: "https://www.instagram.com/thezumocompany/",
    color: "#F0B7A4",
  },
  {
    icon: MessageCircle,
    label: "WhatsApp",
    value: "+974 6684 6261",
    href: "https://wa.me/97466846261",
    color: "#A3B18A",
  },
  {
    icon: Mail,
    label: "Email",
    value: "contact@thezumocompany.com",
    href: "mailto:contact@thezumocompany.com",
    color: "#F0B7A4",
  },
  {
    icon: MapPin,
    label: "Location",
    value: "Doha, Qatar",
    href: null,
    color: "#A3B18A",
  },
];

export default function Contact() {
  return (
    <main data-testid="contact-page" style={{ background: "#FCF8F6" }}>
      {/* Header */}
      <section className="pt-32 pb-12 md:pt-40 md:pb-16">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <p
            className="text-xs uppercase tracking-[0.25em] font-semibold mb-4"
            style={{
              fontFamily: "'Manrope', sans-serif",
              color: "#A3B18A",
            }}
          >
            Get in Touch
          </p>
          <h1
            className="text-5xl sm:text-6xl tracking-tighter leading-none font-medium mb-6"
            style={{
              fontFamily: "'Cormorant Garamond', serif",
              color: "#283618",
            }}
          >
            Contact Us
          </h1>
          <p
            className="text-base md:text-lg leading-relaxed max-w-xl"
            style={{
              fontFamily: "'Manrope', sans-serif",
              color: "#6F5E58",
            }}
          >
            Have a question, want to place a bulk order, or just want to say
            hello? We'd love to hear from you.
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="pb-24 md:pb-32">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24">
            {/* Contact Channels */}
            <div>
              <h2
                className="text-2xl md:text-3xl font-medium mb-10"
                style={{
                  fontFamily: "'Cormorant Garamond', serif",
                  color: "#283618",
                }}
              >
                Reach Us Directly
              </h2>
              <div className="space-y-6">
                {CONTACT_CHANNELS.map((ch, i) => (
                  <div
                    key={ch.label}
                    data-testid={`contact-channel-${ch.label.toLowerCase()}`}
                  >
                    {ch.href ? (
                      <a
                        href={ch.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center gap-5 group p-4 rounded-2xl transition-all duration-300 hover:bg-[#F5D5CB]/50"
                      >
                        <div
                          className="w-12 h-12 rounded-2xl flex items-center justify-center flex-shrink-0 transition-transform duration-300 group-hover:scale-110"
                          style={{ background: `${ch.color}30` }}
                        >
                          <ch.icon size={20} color="#283618" />
                        </div>
                        <div>
                          <p
                            className="text-xs uppercase tracking-[0.15em] font-semibold mb-1"
                            style={{
                              fontFamily: "'Manrope', sans-serif",
                              color: "#A3B18A",
                            }}
                          >
                            {ch.label}
                          </p>
                          <p
                            className="text-base font-medium"
                            style={{
                              fontFamily: "'Manrope', sans-serif",
                              color: "#2A2A2A",
                            }}
                          >
                            {ch.value}
                          </p>
                        </div>
                      </a>
                    ) : (
                      <div className="flex items-center gap-5 p-4">
                        <div
                          className="w-12 h-12 rounded-2xl flex items-center justify-center flex-shrink-0"
                          style={{ background: `${ch.color}30` }}
                        >
                          <ch.icon size={20} color="#283618" />
                        </div>
                        <div>
                          <p
                            className="text-xs uppercase tracking-[0.15em] font-semibold mb-1"
                            style={{
                              fontFamily: "'Manrope', sans-serif",
                              color: "#A3B18A",
                            }}
                          >
                            {ch.label}
                          </p>
                          <p
                            className="text-base font-medium"
                            style={{
                              fontFamily: "'Manrope', sans-serif",
                              color: "#2A2A2A",
                            }}
                          >
                            {ch.value}
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>

            {/* Delivery Partners */}
            <div data-testid="delivery-partners-section">
              <h2
                className="text-2xl md:text-3xl font-medium mb-10"
                style={{
                  fontFamily: "'Cormorant Garamond', serif",
                  color: "#283618",
                }}
              >
                Our Delivery Partners
              </h2>
              <div className="flex items-center gap-10">
                <div
                  data-testid="partner-talabat"
                  className="transition-transform duration-300 hover:scale-105"
                >
                  <img
                    src="https://customer-assets.emergentagent.com/job_zumo-fresh-juice/artifacts/mly882ij_WhatsApp%20Image%202026-04-15%20at%206.41.05%20PM.jpeg"
                    alt="Talabat"
                    className="h-[168px] w-auto object-contain mix-blend-multiply"
                  />
                </div>
                <div
                  data-testid="partner-snoonu"
                  className="transition-transform duration-300 hover:scale-105"
                >
                  <img
                    src="https://customer-assets.emergentagent.com/job_zumo-fresh-juice/artifacts/6cz9am5z_WhatsApp%20Image%202026-04-15%20at%206.39.06%20PM.jpeg"
                    alt="Snoonu"
                    className="h-[168px] w-auto object-contain mix-blend-multiply"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
